// // import React from "react";
// // import "./Footer.css";
// // import { Link } from "react-router-dom";

// // const Footer = () => {
// //   const currentYear = new Date().getFullYear();

// //   return (
// //     <footer className="footer">
// //       <div className="footer-content">
// //         <div className="footer-column">
// //           <div className="logo">
// //             <Link to="/" className="logo-link">
// //               <img
// //                 src="/images/kittynmiceName-rbg.png"
// //                 alt="Kitty-n-Mice"
// //                 className="logo"
// //               />
// //             </Link>
// //           </div>
// //           <p className="footer-text">
// //             Premium kids clothing brand offering stylish, comfortable, and
// //             sustainable fashion for children of all ages. Quality you can trust,
// //             style they'll love.
// //           </p>
// //           <p className="footer-text">support@kittynmice.com</p>
// //         </div>

// //         <div className="footer-column">
// //           <h4 className="footer-title">Quick Links</h4>
// //           <ul className="footer-links">
// //             <li>
// //               <a href="#">About Us</a>
// //             </li>
// //             <li>
// //               <a href="#">Contact</a>
// //             </li>
// //             <li>
// //               <a href="#">Size Guide</a>
// //             </li>
// //             <li>
// //               <a href="#">Shipping Info</a>
// //             </li>
// //           </ul>
// //         </div>

// //         <div className="footer-column">
// //           <h4 className="footer-title">Customer Care</h4>
// //           <ul className="footer-links">
// //             <li>
// //               <a href="#">Track Order</a>
// //             </li>
// //             <li>
// //               <a href="#">FAQs</a>
// //             </li>
// //             <li>
// //               <a href="#">Privacy Policy</a>
// //             </li>
// //             <li>
// //               <a href="#">Terms & Conditions</a>
// //             </li>
// //           </ul>
// //         </div>

// //         <div className="footer-column">
// //           <h4 className="footer-title">Connect With Us</h4>
// //           <div className="social-icons">
// //             <a href="#" className="social-icon" aria-label="Facebook">
// //               📘
// //             </a>
// //             <a href="#" className="social-icon" aria-label="Instagram">
// //               📷
// //             </a>
// //             <a href="#" className="social-icon" aria-label="Twitter">
// //               🐦
// //             </a>
// //             <a href="#" className="social-icon" aria-label="Pinterest">
// //               📌
// //             </a>
// //           </div>
// //           <div className="newsletter">
// //             <h5 className="newsletter-title">Newsletter</h5>
// //             <p className="newsletter-text">Subscribe for exclusive offers</p>
// //             <div className="newsletter-form">
// //               <input
// //                 type="email"
// //                 placeholder="Your email"
// //                 className="newsletter-input"
// //               />
// //               <button className="newsletter-button">Subscribe</button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="footer-bottom">
// //         <p>© {currentYear} Kitty-n-Mice. All rights reserved.</p>
// //       </div>
// //     </footer>
// //   );
// // };

// // export default Footer;

// import React from "react";
// import "./Footer.css";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="footer">
//       <div className="footer-content">
//         <div className="footer-column footer-brand">
//           <div className="footer-logo-wrapper">
//             <Link to="/" className="footer-logo-link">
//               <img
//                 src="/images/kittynmiceName-rbg.png"
//                 alt="Kitty-n-Mice"
//                 className="footer-logo"
//               />
//             </Link>
//           </div>
//           <p className="footer-description">
//             Premium kids clothing brand offering stylish, comfortable, and
//             sustainable fashion for children of all ages. Quality you can trust,
//             style they'll love.
//           </p>
//           <div className="footer-contact">
//             <div className="contact-item">
//               <svg
//                 width="16"
//                 height="16"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
//                 <polyline points="22,6 12,13 2,6" />
//               </svg>
//               <span>support@kittynmice.com</span>
//             </div>
//           </div>
//         </div>

//         <div className="footer-column">
//           <h4 className="footer-title">Quick Links</h4>
//           <ul className="footer-links">
//             <li>
//               <a href="#">About Us</a>
//             </li>
//             <li>
//               <a href="#">Contact</a>
//             </li>
//             <li>
//               <a href="#">Size Guide</a>
//             </li>
//             <li>
//               <a href="#">Shipping Info</a>
//             </li>
//           </ul>
//         </div>

//         <div className="footer-column">
//           <h4 className="footer-title">Customer Care</h4>
//           <ul className="footer-links">
//             <li>
//               <a href="#">Track Order</a>
//             </li>
//             <li>
//               <a href="#">FAQs</a>
//             </li>
//             <li>
//               <a href="#">Privacy Policy</a>
//             </li>
//             <li>
//               <a href="#">Terms & Conditions</a>
//             </li>
//           </ul>
//         </div>

//         <div className="footer-column">
//           <h4 className="footer-title">Stay Connected</h4>
//           <p className="footer-subtitle">Follow us on social media</p>
//           <div className="social-icons">
//             <a href="#" className="social-icon" aria-label="Facebook">
//               <svg
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
//               </svg>
//             </a>
//             <a href="#" className="social-icon" aria-label="Instagram">
//               <svg
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
//               </svg>
//             </a>
//             <a href="#" className="social-icon" aria-label="Twitter">
//               <svg
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
//               </svg>
//             </a>
//             <a href="#" className="social-icon" aria-label="Pinterest">
//               <svg
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z" />
//               </svg>
//             </a>
//           </div>

//           <div className="newsletter">
//             <h5 className="newsletter-title">Newsletter</h5>
//             <p className="newsletter-text">Subscribe for exclusive updates</p>
//             <div className="newsletter-form">
//               <input
//                 type="email"
//                 placeholder="Enter your email"
//                 className="newsletter-input"
//               />
//               <button className="newsletter-button">
//                 <svg
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <line x1="5" y1="12" x2="19" y2="12" />
//                   <polyline points="12 5 19 12 12 19" />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <div className="footer-bottom-content">
//           <p>© {currentYear} Kitty-n-Mice. All rights reserved.</p>
//           <div className="footer-meta">
//             <span>Crafted with care</span>
//             <span className="divider">•</span>
//             <span>Premium Quality</span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Decorative wave divider */}
      <div className="footer-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>

      <div className="footer-content">
        {/* Brand Column */}
        <div className="footer-column footer-brand">
          <div className="footer-logo-wrapper">
            <Link to="/" className="footer-logo-link">
              <img
                src="/images/final_logo.png"
                alt="Kitty n Mice - Premium Kids Clothing"
                className="footer-logo"
              />
            </Link>
          </div>
          <p className="footer-description">
            🎨 Where playful meets premium! Stylish, comfortable, and
            sustainable fashion for children of all ages. Quality you can trust,
            style they'll love.
          </p>
          <div className="footer-contact">
            <div className="contact-item">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              <span>Kittynmice00@gmail.com</span>
            </div>
            <div className="contact-item">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              <span>+91 80762 17714</span>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-links">
            <li>
              <Link to="/about">
                <span className="link-icon">→</span> About Us
              </Link>
            </li>
            <li>
              <Link to="/contact">
                <span className="link-icon">→</span> Contact
              </Link>
            </li>
            {/* <li>
              <Link to="/size-guide">
                <span className="link-icon">→</span> Size Guide
              </Link>
            </li> */}
            {/* <li>
              <Link to="/shipping">
                <span className="link-icon">→</span> Shipping Info
              </Link>
            </li> */}
            {/* <li>
              <Link to="/returns">
                <span className="link-icon">→</span> Returns & Exchange
              </Link>
            </li> */}
          </ul>
        </div>

        {/* Customer Care */}
        <div className="footer-column">
          <h4 className="footer-title">Customer Care</h4>
          <ul className="footer-links">
            <li>
              <Link to="/myaccount">
                <span className="link-icon">→</span> Track Order
              </Link>
            </li>
            {/* <li>
              <Link to="/faqs">
                <span className="link-icon">→</span> FAQs
              </Link>
            </li> */}
            <li>
              <Link to="/privacy">
                <span className="link-icon">→</span> Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions">
                <span className="link-icon">→</span> Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/refund-policy">
                <span className="link-icon">→</span> Return Policy
              </Link>
            </li>
            <li>
              <Link to="/shipping-policy">
                <span className="link-icon">→</span> Shipping Policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Stay Connected */}
        <div className="footer-column">
          <h4 className="footer-title">Stay Connected</h4>
          <p className="footer-subtitle">Join our community! 🌟</p>

          <div className="social-icons">
            {/* <a href="#" className="social-icon facebook" aria-label="Facebook">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a> */}
            <a
              href="https://wa.me/918076217714"
              className="social-icon whatsapp"
              aria-label="WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/kittynmice?igsh=ZmphY3oxenp6aHQ4"
              className="social-icon instagram"
              aria-label="Instagram"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
            {/* <a href="#" className="social-icon twitter" aria-label="Twitter">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
              </svg>
            </a> */}
            {/* <a
              href="#"
              className="social-icon pinterest"
              aria-label="Pinterest"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z" />
              </svg>
            </a> */}
          </div>

          {/* <div className="newsletter">
            <h5 className="newsletter-title">Newsletter 📧</h5>
            <p className="newsletter-text">Get exclusive offers & updates!</p>
            <div className="newsletter-form">
              <input
                type="email"
                placeholder="Your email address"
                className="newsletter-input"
              />
              <button className="newsletter-button" aria-label="Subscribe">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
            </div>
          </div> */}
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>
            © {currentYear} Kitty n Mice. All rights reserved. Made with 💖 for
            kids
          </p>
          <div className="footer-meta">
            <span>✨ Crafted with Care</span>
            <span className="divider">•</span>
            <span>🌟 Premium Quality</span>
            <span className="divider">•</span>
            <span>🌍 Sustainable Fashion</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
